import { selectPromotion } from 'store/campaign/campaignActions';
import { createSelectPromotionEvent } from '../eventCreators';
import { createSelectPromotionEventPayload } from '../dataHelpers/createSelectPromotionEventPayload';

const emitSelectPromotion = ({ payload }) => {
  const selectPromotionEvent = createSelectPromotionEvent(
    createSelectPromotionEventPayload({
      promotion: payload.promotion,
    }),
  );

  return selectPromotionEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [selectPromotion]: emitSelectPromotion };
